var n = (c, t, o) => new Promise((s, r) => {
  var i = (e) => {
    try {
      a(o.next(e));
    } catch (l) {
      r(l);
    }
  }, m = (e) => {
    try {
      a(o.throw(e));
    } catch (l) {
      r(l);
    }
  }, a = (e) => e.done ? s(e.value) : Promise.resolve(e.value).then(i, m);
  a((o = o.apply(c, t)).next());
});
import { selfAxios as f } from "@oppein/op-utils";
function p(c) {
  return n(this, null, function* () {
    const { data: t } = yield f.get(
      "/bsplatform/external/commodity/selectFaucetModel",
      { params: c }
    );
    return t == null ? void 0 : t.data;
  });
}
export {
  p as getSelectFaucetModel
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/bsplatform/external/commodity/selectFaucetModel/get.js
// module id = 1754
// module chunks = 41